/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, themeV2 } from '@insticator/insticator-ui';

/* ++++++++++ --------------- REPORT BUILDER: PREVIEW --------------- ++++++++++ */
export default {
  preview: {
    '& .table': {
      marginTop: pxToEm(25)
    },

    '& th': {
      backgroundColor: `${themeV2.color.base.blue.light} !important`
    },

    '& .specialrow': {
      '& .column': {
        color: `${themeV2.color.primary.main} !important`,
        backgroundColor: `${themeV2.color.base.blue.light} !important`
      }
    },

    '& .rowCount': {
      color: themeV2.color.base.gray.secondary,
      marginTop: pxToEm(25)
    }
  }
};